import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Header';
import Sidebar from './Sidebar';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // Default to collapsed (icons only)
  
  // Toggle sidebar open/close
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  
  // Width of the sidebar when collapsed (just icons)
  const collapsedWidth = 'w-16'; // Tailwind class for 64px
  const expandedWidth = 'w-58'; // Reduced from w-60 to w-48 (192px instead of 240px)
  
  return (
    <div className="flex flex-col h-screen bg-gray-100 ">
      {/* Navbar - Full Width */}
      <Navbar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
      
      {/* Content Container */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar - Always visible but width changes */}
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          variant="permanent" // Always visible
          collapsedWidth={collapsedWidth}
          expandedWidth={expandedWidth}
        />
        
        {/* Main Content */}
        <main
          className={`flex-1 overflow-y-auto p-2 transition-all duration-300 ${
            sidebarOpen ? 'ml-1' : 'ml-1' // Adjusted ml-60 to ml-48
          }`}
        >
          
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;